import '@/app/app.css';
import './shipping.css';

import '@/app/app';

import { ShippingGallery } from '@/features/shipping/shipping-gallery/shipping-gallery';

document.addEventListener('DOMContentLoaded', () => {
	const shippingGallery = document.querySelector('.js-shipping-gallery');
	shippingGallery && new ShippingGallery(shippingGallery);

	const shippingVideo = document.querySelector('.about-video .js-video');
	if (shippingVideo) {
		shippingVideo.classList.add('js-video--observer');
		shippingVideo.querySelector('video').muted = true;
		app.classInstance.get(shippingVideo)?.video.play();
	}
});
